// App.js
import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'; // เพิ่ม useNavigate ที่นี่
import Login from './Components/Login';
import Exercies from './Components/Exercies';
import VideoDisp from './Components/VideoDisp';
import MatchGame from './game1/matchgame';
import SlotGame from './game2/SlotGame';
import Leaderboard from './Components/Leaderboard';
import History from './Components/History';
import SpacialExecries from './SpacialExecries/SpacialExecries';
import './App.css';
import { db } from './Firebase';
import { doc, getDoc } from 'firebase/firestore';
import 'antd/dist/reset.css'; // ตรวจสอบให้แน่ใจว่าได้ติดตั้ง antd แล้ว

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate(); // ประกาศ useNavigate ที่นี่

  // ฟังก์ชันสำหรับดึงข้อมูลผู้ใช้จาก Firestore
  const fetchUserData = useCallback(async (username) => {
    if (!username) {
      console.warn("Username is null or empty, cannot fetch user data.");
      setIsLoggedIn(false); // ตรวจสอบให้แน่ใจว่าไม่ได้ล็อกอิน
      setUserData(null);
      localStorage.removeItem('loggedInUser'); // ลบข้อมูลที่อาจเสียหาย
      return;
    }
    
    try {
      // ใช้ document ID เดียวกับที่ Login ใช้ (ไม่แปลงเป็นตัวเล็ก)
      const userRef = doc(db, "Competition-Training", username);
      const docSnap = await getDoc(userRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        setUserData({
          username: data.username,
          level: data.level || 0,
          score: data.score || 0,
          bonus: data.bonus || false,
          'Spacial-Level': data['Spacial-Level'] || 0,  // เพิ่มฟิลด์ Spacial-Level
          'Level-ID': data['Level-ID'] || 0  // เพิ่มฟิลด์ Level-ID
        });
        localStorage.setItem('loggedInUser', JSON.stringify({
          username: data.username,
          level: data.level || 0,
          score: data.score || 0,
          'Spacial-Level': data['Spacial-Level'] || 0,  // เพิ่มฟิลด์ Spacial-Level
          'Level-ID': data['Level-ID'] || 0  // เพิ่มฟิลด์ Level-ID
        }));
        setIsLoggedIn(true); // ตั้งค่าเป็น true เมื่อดึงข้อมูลได้สำเร็จ
      } else {
        // หากไม่พบข้อมูลผู้ใช้ใน Firestore ทั้งๆ ที่มีใน localStorage, ให้ Logout
        console.warn(`User ${username} not found in Firestore. Logging out.`);
        handleLogout(); 
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      // หากเกิดข้อผิดพลาดในการดึงข้อมูล ให้ Logout เพื่อป้องกันสถานะที่ไม่สอดคล้องกัน
      handleLogout();
    }
  }, [navigate]); // เพิ่ม navigate ใน dependency array เนื่องจากเรียกใช้ handleLogout

  // ฟังก์ชันสำหรับจัดการการออกจากระบบ
  const handleLogout = useCallback(() => {
    setIsLoggedIn(false);
    setUserData(null);
    localStorage.removeItem('loggedInUser'); // ลบข้อมูลการล็อกอินออกจาก localStorage
    navigate('/'); // นำทางกลับไปที่หน้า Login
  }, [navigate]); // เพิ่ม navigate ใน dependency array

  // useEffect สำหรับตรวจสอบสถานะการล็อกอินจาก localStorage เมื่อโหลด App ครั้งแรก
  useEffect(() => {
    const storedUser = localStorage.getItem('loggedInUser');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        if (parsedUser && parsedUser.username) {
          // ไม่ต้อง setIsLoggedIn(true) ตรงนี้โดยตรง เพราะ fetchUserData จะทำหลังจากดึงข้อมูลสำเร็จ
          fetchUserData(parsedUser.username);
        } else {
          // หากข้อมูลใน localStorage ไม่ถูกต้อง ให้ลบทิ้ง
          localStorage.removeItem('loggedInUser');
          setIsLoggedIn(false);
        }
      } catch (e) {
        console.error("Failed to parse stored user data:", e);
        localStorage.removeItem('loggedInUser'); // ลบข้อมูลที่ไม่ถูกต้อง
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false); // ไม่มีข้อมูลใน localStorage ก็ต้องแน่ใจว่า isLoggedIn เป็น false
    }
  }, [fetchUserData]); // เพิ่ม fetchUserData ใน dependency array

  // ฟังก์ชันที่ถูกเรียกเมื่อ Login สำเร็จ
  const handleLoginSuccess = useCallback((user) => {
    // user ที่ส่งมาอาจจะมีข้อมูลครบถ้วนแล้ว หรือแค่ username ก็ได้
    // ในที่นี้เราจะยังคงใช้ fetchUserData เพื่อให้แน่ใจว่าดึงข้อมูลล่าสุดจาก Firestore
    setIsLoggedIn(true); // ตั้งค่าสถานะการล็อกอิน
    setUserData(user); // ตั้งค่าข้อมูลผู้ใช้เบื้องต้น
    localStorage.setItem('loggedInUser', JSON.stringify(user)); // บันทึกข้อมูลลง localStorage
    // fetchUserData(user.username); // ถ้าต้องการดึงข้อมูลเต็มรูปแบบหลัง Login สำเร็จ
  }, []);

  // ฟังก์ชันสำหรับอัปเดตข้อมูลผู้ใช้ (ถูกส่งไปให้ VideoDisp และ MatchGame)
  const handleUserUpdate = useCallback((username) => {
    fetchUserData(username); // เมื่อมีการอัปเดตข้อมูล ให้ดึงข้อมูลผู้ใช้ล่าสุด
  }, [fetchUserData]);

  return (
    <div className="App">
      <Routes>
        {/* Route สำหรับหน้าหลัก (Login / Exercies) */}
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/exercies" />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />

        {/* Route สำหรับหน้าแบบฝึกหัด (Exercies) */}
        <Route
          path="/exercies"
          element={
            isLoggedIn ? (
              <Exercies userData={userData} onLogout={handleLogout} onUserUpdate={handleUserUpdate} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Route สำหรับหน้าแสดงวิดีโอ (VideoDisp) */}
        <Route
          path="/video"
          element={
            isLoggedIn ? (
              <VideoDisp userData={userData} onUserUpdate={handleUserUpdate} />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        
        {/* Route สำหรับหน้าเกมจับคู่ (MatchGame) */}
        <Route
          path="/match-game"
          element={
            isLoggedIn ? (
              <MatchGame userData={userData} onUserUpdate={handleUserUpdate} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Route สำหรับหน้าเกมสล็อต (SlotGame) */}
        <Route
          path="/slot-game"
          element={
            isLoggedIn ? (
              <SlotGame userData={userData} onUserUpdate={handleUserUpdate} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Route สำหรับหน้ากระดานผู้นำ (Leaderboard) */}
        <Route
          path="/leaderboard"
          element={
            isLoggedIn ? (
              <Leaderboard userData={userData} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Route สำหรับหน้า History */}
        <Route
          path="/history"
          element={
            isLoggedIn ? (
              <History userData={userData} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Route สำหรับ SpacialExecries */}
        <Route
          path="/spacial-execries"
          element={
            isLoggedIn ? (
              <SpacialExecries userData={userData} onUserUpdate={handleUserUpdate} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Route Catch-all สำหรับเส้นทางที่ไม่รู้จัก จะนำกลับไปหน้าหลัก */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;